import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const NavBar = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const mainPath = pathSegments?.[1];
  const subPath = pathSegments?.[2];
  const thirdSegment = pathSegments?.[3];

  const isMainPage =
    (mainPath !== "auditForms" || mainPath !== "audits") && !subPath;

  const isDetailPage =
    ["users", "roles", "feedback-requests", "forms", "settings"].includes(
      mainPath
    ) &&
    subPath &&
    subPath !== "preview";

  const clientEscalationDetailPage =
    mainPath === "escalations" &&
    (subPath === "client-escalation" || subPath === "internal-error-rca") &&
    !thirdSegment;

  const auditFormEditPage = mainPath === "auditForms" && thirdSegment;

  const condition =
    isMainPage ||
    isDetailPage ||
    auditFormEditPage ||
    clientEscalationDetailPage === true;

  const [isActive, setIsActive] = useState(
    secureLocalStorage.getItem("isSubMenuActive") || "qms"
  );

  const [isSubMenuActive, setIsSubMenuActive] = useState(
    secureLocalStorage.getItem("isSubMenuActive") || "qms"
  );

  const [isFeedbackRequestsActive, setIsFeedbackRequestsActive] =
    useState(false);

  const [isEscalationsActive, setIsEscalationsActive] = useState(false);

  const handleClick = (val) => {
    setIsActive(val);
  };

  const handleSubMenuClick = (val, path) => {
    path = path && path.replace("/", "");
    const lastPageSearchIn = secureLocalStorage.getItem("lastPageSearchIn");
    if (path && lastPageSearchIn) {
      if (path !== lastPageSearchIn) {
        const searchKeywordOnRefresh = document.querySelector(".inputS");
        if (searchKeywordOnRefresh) {
          searchKeywordOnRefresh.value = ""; // Clears the text in the input field
        }
        if (secureLocalStorage.getItem("hasSearchedValue")) {
          secureLocalStorage.removeItem("hasSearchedValue");
        }
        if (secureLocalStorage.getItem("searchKeyword")) {
          secureLocalStorage.removeItem("searchKeyword");
        }
      }
    }
    setIsSubMenuActive((state) => ({
      ...state,
      isSubMenuActive: val,
    }));
    secureLocalStorage.removeItem("isSubMenuActive");

    secureLocalStorage.setItem("isSubMenuActive", val);
    setIsFeedbackRequestsActive(false);
    setIsEscalationsActive(false);
  };

  const handleFeedbackRequestsClick = (val) => {
    
    if (secureLocalStorage.getItem("isFeedbackRequestsActive") === "freq") {
      setIsFeedbackRequestsActive(false);
    } else {
      setIsFeedbackRequestsActive(val);
    }
  };

  const handleClientEscalationClick = (val) => {
    
    if (
      secureLocalStorage.getItem("isEscalationsActive") === "client-escalation"
    ) {
      setIsEscalationsActive(false);
    } else {
      setIsEscalationsActive(val);
    }
  };

  const role = secureLocalStorage.getItem("role");

  const qmsLinks = {
    admin: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/auditForms", label: "Audit Forms", icon: "fa fa-wpforms" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
      { path: "/deleted-audits", label: "Deleted Audits", icon: "Audits.png" },
      // { path: "/escalations", label: "Escalations", icon: "escalations.png" },
      {
        path: "",
        label: "Escalations",
        icon: "escalations.png",
        subLinks: [
          {
            path: "/escalations/client-escalation",
            label: "Client Escalation",
            icon: "escalations.png",
          },
          {
            path: "/escalations/internal-error-rca",
            label: "Internal Error RCA",
            icon: "escalations.png",
          },
        ],
      },
      { path: "/processes", label: "Processes", icon: "fa fa-refresh" },
      { path: "/clients", label: "Clients", icon: "fa fa-user-secret" },
      { path: "/departments", label: "Departments", icon: "fa fa-building-o" },
    ],
    agent: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
    ],
    atl: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
    ],
    auditor: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/auditForms", label: "Audit Forms", icon: "fa fa-wpforms" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
      { path: "/deleted-audits", label: "Deleted Audits", icon: "Audits.png" },
    ],
    qc: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/departments", label: "Departments", icon: "fa fa-building-o" },
      { path: "/processes", label: "Processes", icon: "fa fa-refresh" },
      { path: "/auditForms", label: "Audit Forms", icon: "fa fa-wpforms" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
      { path: "/deleted-audits", label: "Deleted Audits", icon: "Audits.png" },
      // { path: "/escalations", label: "Escalations", icon: "escalations.png" },
      {
        path: "",
        label: "Escalations",
        icon: "escalations.png",
        subLinks: [
          {
            path: "/escalations/client",
            label: "Client Escalation",
            icon: "escalations.png",
          },
        ],
      },
    ],
    tl: [
      { path: "/dashboard", label: "Dashboard", icon: "fa fa-home" },
      { path: "/audits", label: "Audits", icon: "Audits.png" },
    ],
    manager: [{ path: "/dashboard", label: "Dashboard", icon: "fa fa-home" }],
  };

  const vocLinks = {
    admin: [
      { path: "/forms/add", label: "Add Form", icon: "fa fa-wpforms" },
      { path: "/forms", label: "Forms", icon: "fa fa-wpforms" },
      {
        path: "",
        label: "Feedback Requests",
        icon: "fa fa-commenting-o",
        subLinks: [
          {
            path: "/feedback-requests/open",
            label: "Open",
            icon: "fa fa-commenting-o",
          },
          {
            path: "/feedback-requests/closed",
            label: "Closed",
            icon: "fa fa-commenting-o",
          },
          {
            path: "/feedback-requests/expired",
            label: "Expired",
            icon: "fa fa-commenting-o",
          },
        ],
      },
    ],
    qc: [
      { path: "/forms", label: "Forms", icon: "fa fa-wpforms" },
      {
        path: "",
        label: "Feedback Requests",
        icon: "fa fa-commenting-o",
        subLinks: [
          {
            path: "/feedback-requests/open",
            label: "Open",
            icon: "fa fa-commenting-o",
          },
          {
            path: "/feedback-requests/closed",
            label: "Closed",
            icon: "fa fa-commenting-o",
          },
          {
            path: "/feedback-requests/expired",
            label: "Expired",
            icon: "fa fa-commenting-o",
          },
        ],
      },
    ],
  };

  const settingLinks = {
    admin: [
      {
        path: "/settings/theme-options",
        label: "Theme Options",
        icon: "fa fa-wpforms",
      },
      {
        path: "/settings/import-bulk-data",
        label: "Import Bulk Data",
        icon: "fa fa-wpforms",
      },
      {
        path: "/settings/role-access-control",
        label: "Role Access Control",
        icon: "fa fa-wpforms",
      },
      {
        path: "/users",
        label: "Manage Users",
        icon: "fa fa-users",
      },
    ],
  };

  const renderSubLinks = (subLinks) => {
    return subLinks.map(({ path, label, icon }) => (
      <Link
        key={label}
        to={path}
        onClick={() => {
          label === "Feedback Requests"
            ? handleFeedbackRequestsClick("freq")
            : label === "Client Escalation" || label === "Internal Error RCA"
            ?  handleSubMenuClick("qms", path)            
            : handleSubMenuClick("voc", path);
        }}
        className="links"
        style={{ backgroundColor: location.pathname === path ? "#EDF1F4" : "" }}
      >
        {label !== "Client Escalation" && label !== "Internal Error RCA" ? (
          icon.startsWith("fa") ? (
            <i className={icon} aria-hidden="true"></i>
          ) : (
            <img src={`/${icon}`} alt="logo" />
          )
        ) : (
          ""
        )}
        <span className="dashboardstyle">{label}</span>
      </Link>
    ));
  };

  useEffect(() => {
    const submenu = secureLocalStorage.getItem("isSubMenuActive");

    if (mainPath === "dashboard") {
      setIsActive("qms");
      secureLocalStorage.removeItem("isSubMenuActive"); // Clean it up after use
    }
  }, [mainPath]);

  return (
    <>
      {condition ? (
        <div className="sidenav">
          <div className="menu">
            {/*QMS*/}
            <div className={isActive === "qms" ? "menuActive" : ""}>
              <span
                className="d-block links"
                onClick={() => handleClick("qms")}
              >
                QMS
                <i
                  className={
                    isActive === "qms"
                      ? "fa fa-angle-up dropdown"
                      : "fa fa-angle-down dropdown"
                  }
                />
              </span>
              <div
                className={
                  isActive === "qms" ? "activeClass" : "inactiveClass dropwdown"
                }
              >
                {qmsLinks[role].map(({ path, label, icon, subLinks }) => (
                  <React.Fragment key={label}>
                    {label === "Escalations" ? (
                      <span
                        key={label}
                        className={
                          (location.pathname.split("/")[1] === "escalations" &&
                            location.pathname.split("/")[2]) ||
                          isEscalationsActive !== false
                            ? "d-block links subMnu subMnuActive escalation"
                            : "d-block links subMnu escalation"
                        }
                        onClick={() => {
                          label === "Escalations"
                            ? handleClientEscalationClick("client-escalation")
                            : handleSubMenuClick("qms", path);
                        }}
                      >
                        {icon.startsWith("fa") ? (
                          <i className={icon} aria-hidden="true"></i>
                        ) : (
                          <img src={`/${icon}`} alt="logo" />
                        )}

                        <span className="dashboardstyle">{label}</span>
                        <i
                          className={
                            (location.pathname.split("/")[1] ===
                              "escalations" &&
                              location.pathname.split("/")[2]) ||
                            isEscalationsActive !== false
                              ? "fa fa-angle-up dropdown"
                              : "fa fa-angle-down dropdown"
                          }
                        />
                      </span>
                    ) : (
                      <Link
                        key={label}
                        to={path}
                        className="links"
                        onClick={() => handleSubMenuClick("qms", path)}
                        style={{
                          backgroundColor:
                            location.pathname === path ? "#EDF1F4" : "",
                        }}
                      >
                        {icon.startsWith("fa") ? (
                          <i className={icon} aria-hidden="true"></i>
                        ) : (
                          <img src={`/${icon}`} alt="logo" />
                        )}
                        <span className="dashboardstyle">{label}</span>
                      </Link>
                    )}
                    {subLinks && (
                      <div
                        className={
                          (location.pathname.split("/")[1] === "escalations" &&
                            location.pathname.split("/")[2]) ||
                          isEscalationsActive !== false
                            ? "activeClass subMnuChildActive escalation"
                            : "inactiveClass dropwdown escalation"
                        }
                      >
                        {renderSubLinks(subLinks)}{" "}
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/*VOC*/}
            {role === "admin" || role === "qc" ? (
              <div className={isActive === "voc" ? "menuActive" : ""}>
                <span
                  className="d-block links"
                  onClick={() => handleClick("voc")}
                >
                  VOC
                  <i
                    className={
                      isActive === "voc"
                        ? "fa fa-angle-up dropdown"
                        : "fa fa-angle-down dropdown"
                    }
                  />
                </span>
                <div
                  className={
                    isActive === "voc"
                      ? "activeClass"
                      : "inactiveClass dropwdown"
                  }
                >
                  {vocLinks[role].map(({ path, label, icon, subLinks }) => (
                    <React.Fragment key={label}>
                      {label === "Feedback Requests" ? (
                        <span
                          key={label}
                          className={
                            (location.pathname.split("/")[1] ===
                              "feedback-requests" &&
                              location.pathname.split("/")[2]) ||
                            isFeedbackRequestsActive !== false
                              ? "d-block links subMnu subMnuActive"
                              : "d-block links subMnu"
                          }
                          onClick={() => {
                            label === "Feedback Requests"
                              ? handleFeedbackRequestsClick("freq")
                              : handleSubMenuClick("voc", path);
                          }}
                        >
                          {label}

                          <i
                            className={
                              (location.pathname.split("/")[1] ===
                                "feedback-requests" &&
                                location.pathname.split("/")[2]) ||
                              isFeedbackRequestsActive !== false
                                ? "fa fa-angle-up dropdown"
                                : "fa fa-angle-down dropdown"
                            }
                          />
                        </span>
                      ) : (
                        <Link
                          key={label}
                          to={path}
                          className="links"
                          onClick={() => handleSubMenuClick("voc", path)}
                          style={{
                            backgroundColor:
                              location.pathname === path ? "#EDF1F4" : "",
                          }}
                        >
                          <i className={icon} aria-hidden="true"></i>
                          <span className="dashboardstyle">{label}</span>
                          {subLinks && (
                            <i
                              className={
                                (location.pathname.split("/")[1] ===
                                  "feedback-requests" &&
                                  location.pathname.split("/")[2]) ||
                                isFeedbackRequestsActive !== false
                                  ? "fa fa-angle-up dropdown"
                                  : "fa fa-angle-down dropdown"
                              }
                              style={{ float: "right" }}
                            />
                          )}
                        </Link>
                      )}
                      {subLinks && (
                        <div
                          className={
                            (location.pathname.split("/")[1] ===
                              "feedback-requests" &&
                              location.pathname.split("/")[2]) ||
                            isFeedbackRequestsActive !== false
                              ? "activeClass subMnuChildActive"
                              : "inactiveClass dropwdown"
                          }
                        >
                          {renderSubLinks(subLinks)}{" "}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ) : null}

            {/*Settings*/}
            {role === "admin" && (
              <>
                <div className={isActive === "settings" ? "menuActive" : ""}>
                  <span
                    className="d-block links"
                    onClick={() => handleClick("settings")}
                  >
                    Settings
                    <i
                      className={
                        isActive === "settings"
                          ? "fa fa-angle-up dropdown"
                          : "fa fa-angle-down dropdown"
                      }
                    />
                  </span>

                  <div
                    className={
                      isActive === "settings"
                        ? "activeClass"
                        : "inactiveClass dropwdown"
                    }
                  >
                    {settingLinks[role].map(
                      ({ path, label, icon, subLinks }) => (
                        <React.Fragment key={label}>
                          {label === "Feedback Requests" ? (
                            <span
                              key={label}
                              className={
                                (location.pathname.split("/")[1] ===
                                  "feedback-requests" &&
                                  location.pathname.split("/")[2]) ||
                                isFeedbackRequestsActive !== false
                                  ? "d-block links subMnu subMnuActive"
                                  : "d-block links subMnu"
                              }
                              onClick={() => {
                                label === "Feedback Requests"
                                  ? handleFeedbackRequestsClick("freq")
                                  : handleSubMenuClick("settings", path);
                              }}
                            >
                              {label}

                              <i
                                className={
                                  (location.pathname.split("/")[1] ===
                                    "feedback-requests" &&
                                    location.pathname.split("/")[2]) ||
                                  isFeedbackRequestsActive !== false
                                    ? "fa fa-angle-up dropdown"
                                    : "fa fa-angle-down dropdown"
                                }
                              />
                            </span>
                          ) : (
                            <Link
                              key={label}
                              to={path}
                              className="links"
                              onClick={() =>
                                handleSubMenuClick("settings", path)
                              }
                              style={{
                                backgroundColor:
                                  location.pathname === path ? "#EDF1F4" : "",
                              }}
                            >
                              <i className={icon} aria-hidden="true"></i>
                              <span className="dashboardstyle">{label}</span>
                              {subLinks && (
                                <i
                                  className={
                                    (location.pathname.split("/")[1] ===
                                      "feedback-requests" &&
                                      location.pathname.split("/")[2]) ||
                                    isFeedbackRequestsActive !== false
                                      ? "fa fa-angle-up dropdown"
                                      : "fa fa-angle-down dropdown"
                                  }
                                  style={{ float: "right" }}
                                />
                              )}
                            </Link>
                          )}
                          {subLinks && (
                            <div
                              className={
                                (location.pathname.split("/")[1] ===
                                  "feedback-requests" &&
                                  location.pathname.split("/")[2]) ||
                                isFeedbackRequestsActive !== false
                                  ? "activeClass subMnuChildActive"
                                  : "inactiveClass dropwdown"
                              }
                            >
                              {renderSubLinks(subLinks)}{" "}
                            </div>
                          )}
                        </React.Fragment>
                      )
                    )}
                  </div>
                </div>
              </>
            )}

            {/*Switch Role*/}
            {secureLocalStorage.getItem("empID") ===
              Number(process.env.REACT_APP_SROLE_ID) && (
              <div className={isActive === "switch-role" ? "menuActive" : ""}>
                <Link
                  to="/switch-role"
                  className="d-block links"
                  onClick={() => {
                    handleClick("switch-role");
                    handleSubMenuClick("switch-role");
                  }}
                >
                  <span className="dashboardstyle settings">Switch Role</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default NavBar;
